'use memo';

import { lazy, Suspense } from 'react';
import { Text } from '@/components/Typography';

// react-markdown / remark エコシステムは比較的大きいため、
// チャット利用時のみロードする（メインバンドルから分離）。
const AiChatMarkdownContent = lazy(() => import('./AiChatMarkdownContent'));
type AiChatMarkdownProps = {
  content: string;
};
export function AiChatMarkdown({
  content
}: AiChatMarkdownProps) {
  return <Suspense
  // ロード完了までは従来どおりプレーンテキストで表示する
  fallback={<Text variant="pSmall" className="whitespace-pre-wrap text-neutral-on-fill">
          {content}
        </Text>}>
      <AiChatMarkdownContent content={content} />
    </Suspense>;
}